import { PluginEntitiesResponse } from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runDeleteGuarantorForm = (
  constructPost: ConstructPost,
  data: { params: { uuid: string } },
): Promise<
  | NonPaginatedResponse<PluginEntitiesResponse<'individuals' | 'businesses'>>
  | undefined
> =>
  constructPost<
    NonPaginatedResponse<PluginEntitiesResponse<'individuals' | 'businesses'>>
  >(`${PLUGIN_BASE_PATH}/delete-guarantor-form`, { data });
